import { rem } from 'polished'

import { css, styled } from '../../theme'
import { colors } from '../../theme/colors'
import { font } from '../../theme/font'
import { media } from '../../theme/media'
import ArrowDownIcon from './ArrowDownIcon'

export const Wrapper = styled.label`
  position: relative;
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
  width: 100%;
  height: ${rem(60)};
`

export const Caption = styled.div.attrs({})<{ hasError?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  padding-right: ${rem(5)};

  ${font.s()};
  color: ${colors.black};

  border-bottom: 1px solid
    ${p => (p.hasError ? colors.ternary : colors.primary)};
`

export const CaptionText = styled.span.attrs({})<{
  forceFullText?: boolean
}>`
  flex-grow: 1;
  height: ${rem(30)};
  font-size: ${font.s()};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${p =>
    p.forceFullText &&
    css`
      overflow: visible;
      text-overflow: clip;
    `}
`

export const ArrowDownIconStyled = styled(ArrowDownIcon).attrs({})<{
  hasError?: boolean
}>`
  width: ${rem(20)};
  height: ${rem(20)};
  flex-shrink: 0;

  fill: ${p => (p.hasError ? colors.ternary : colors.primary)};
`

export const SelectField = styled.select.attrs({})<{ hasError?: boolean }>`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  opacity: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  z-index: 2;
`

export const Label = styled.span.attrs({})<{
  required: boolean
  elevated: boolean
}>`
  display: block;
  position: absolute;
  top: ${rem(25)};
  left: 0;
  width: 100%;

  ${font.m()}
  color: ${colors.grayDark};
  z-index: 2;
  transition: top 0.2s ease, font-size 0.2s ease, color 0.2s ease;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  ${p =>
    p.elevated &&
    css`
      top: 0;
      ${media.onlyMobile` ${font.xs()}`};
      ${media.tablet` ${font.s()}`};
    `}

  ${p =>
    p.required &&
    css`
      &:after {
        content: '*';
      }
    `}
`
export const OptionField = styled.option`
  font-size:${media.onlyMobile ? font.m() : font.s()};
/*   ${media.tablet && font.s()};
  ${media.onlyMobile && font.m()}; */
`

export const ErrorMessage = styled.div`
  color: ${colors.ternaryDark};
  font-size: ${font.s()};
`
